import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { TailSpin } from 'react-loader-spinner';
import './App.css'; // Importing external CSS file

const App = () => {
  const [reservations, setReservations] = useState([]);
  const [date, setDate] = useState(() => {
    const today = new Date();
    const dayAfterTomorrow = new Date(today);
    dayAfterTomorrow.setDate(today.getDate() + 2);
    return dayAfterTomorrow.toISOString().split('T')[0];
  });
  const [startTime, setStartTime] = useState('09:45');
  const [endTime, setEndTime] = useState('17:00');
  const [token, setToken] = useState('');
  const [nowait, setNowait] = useState(false);
  const [tokenExp, setTokenExp] = useState('');
  const [password, setPassword] = useState(localStorage.getItem('password') || '');
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('password'));
  const [isRefreshLoading, setIsRefreshLoading] = useState(false);
  const [isBookLoading, setIsBookLoading] = useState(false);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [checkinLoadingState, setCheckinLoadingState] = useState({});
  const [cancelLoadingState, setCancelLoadingState] = useState({});

  const [bookDesk, setBookDesk] = useState(true);
  const [parkingPlace, setParkingPlace] = useState('');

  const API_BASE = '/api';

// Fetch reservations (default 10)
  const fetchReservations = async () => {
    try {
      setIsRefreshLoading(true);
      const response2 = await axios.get(`${API_BASE}/token`, { params: { password } });
      setTokenExp(response2.data);
      const response = await axios.get(`${API_BASE}/list`, { params: { password } });
      setReservations(
        response.data.slice(0, 10).map((res) => ({
          id: res.id,
          date: res.date,
          startTime: res.start_time,
          endTime: res.end_time,
          status: res.status,
          details: res.details,
          canCheckIn: res.can_check_in, // Capture can_check_in value
          canCheckOut: res.can_check_out,
        }))
      );
    } catch (error) {
      if (error.response?.data?.error) {
        alert(`Error: ${error.response.data.error}`);
      } else {
        alert(`Error fetching reservation: ${error.message}`);
        console.error('Error fetching reservation:', error);
      }
    } finally {
      setIsRefreshLoading(false);
    }
  };


useEffect(() => {
    if (!isAuthenticated) {
      const userPassword = prompt('Enter password:');
      if (userPassword) {
        setPassword(userPassword);
        localStorage.setItem('password', userPassword);
        setIsAuthenticated(true);
      }
    } else {
      fetchReservations();
    }
  }, [isAuthenticated]);

  // Book a new reservation
  const handleBook = async () => {
    try {
      setIsBookLoading(true);
      const formattedDate = date.split('-').reverse().join('-');

      await axios.get(`${API_BASE}/book`, {
        params: {
          date: formattedDate,  // Send the formatted date as dd-mm-yyyy
          start_time: startTime,
          end_time: endTime,
          book_desk: bookDesk,
          parking_place: parkingPlace.trim(),
          password,
        },
      });
      alert('Reservation created successfully!');
      fetchReservations();
    } catch (error) {
      if (error.response?.data?.error) {
        alert(`Error: ${error.response.data.error}`);
      } else {
        alert(`Error creating reservation: ${error.message}`);
        console.error('Error creating reservation:', error);
      }
    } finally {
      setIsBookLoading(false);
    }
  };


  // Cancel a reservation
  const handleCancel = async (id) => {
    try {
      setCancelLoadingState(prevState => ({ ...prevState, [id]: true }));
      await axios.get(`${API_BASE}/cancel`, {
        params: { task_id: id,
                  password, },
      });
      alert('Reservation cancelled successfully!');
      fetchReservations();
    } catch (error) {
      if (error.response?.data?.error) {
        alert(`Error: ${error.response.data.error}`);
      } else {
        alert(`Error cancelling reservation: ${error.message}`);
        console.error('Error cancelling reservation:', error);
      }
    } finally {
      setCancelLoadingState(prevState => ({ ...prevState, [id]: false })); 
    }
  };

  const removeStoredPassword = () => {
    localStorage.removeItem('password');
    setPassword('');
    setIsAuthenticated(false);
  };



// Update the token for an existing reservation
  const handleUpdateToken = async () => {
    try {
      setIsUpdateLoading(true);
      await axios.get(`${API_BASE}/update_token`, {
        params: {
          token: token,
          password,  // The new token value
        },
      });
      alert('Token updated successfully!');
      fetchReservations();
    } catch (error) {
      if (error.response?.data?.error) {
        alert(`Error: ${error.response.data.error}`);
      } else {
        alert(`Error updating token: ${error.message}`);
        console.error('Error updating token:', error);
      }
    } finally {
      setIsUpdateLoading(false);
    }
  };

  const handleCheckIn = async (id) => {
    try {
      setCheckinLoadingState(prevState => ({ ...prevState, [id]: true })); 
      await axios.get(`${API_BASE}/checkin`, {
        params: { task_id: id,
                  password, },
      });
      alert('Checked in successfully!');
      fetchReservations();
    } catch (error) {
      if (error.response?.data?.error) {
        alert(`Error: ${error.response.data.error}`);
      } else {
        alert(`Error checking in: ${error.message}`);
        console.error('Error checking in:', error);
      }
    } finally {
      setCheckinLoadingState(prevState => ({ ...prevState, [id]: false })); 
    }
  };



  return (
    <div className="container">
      <h1 className="title">Rocket Launches Reservation System</h1>
      <h2>Token expiration date</h2>
        {tokenExp}
      {/* Reservations List */}
      <h2>Reservations</h2>
      <table className="table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Status</th>
            <th>Details</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {reservations.map((res, index) => (
            <tr key={index}>
              <td>{res.date}</td>
              <td>{res.startTime}</td>
              <td>{res.endTime}</td>
              <td>{res.status}</td>
              <td>{res.details}</td>
              <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
        <button 
                  className="checkin-btn" 
                  onClick={() => handleCheckIn(res.id)} 
                  disabled={!res.canCheckIn || checkinLoadingState[res.id]}
                >
                  {checkinLoadingState[res.id] ? <TailSpin color="white" height={20} width={20} /> : "Check in"}
                </button>
                <button disabled={cancelLoadingState[res.id]} className="cancel-btn" onClick={() => handleCancel(res.id)}>
                {cancelLoadingState[res.id] ? <TailSpin color="white" height={20} width={20} /> : res.canCheckOut ? 'Check out' : 'Cancel'}
                </button>
              </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="form-container">
      <button className="book-btn" onClick={fetchReservations} disabled={isRefreshLoading}>
            {isRefreshLoading ? <TailSpin color="white" height={20} width={20} /> : "Refresh"}</button>
      </div>

      {/* New Reservation Form */}
      <h2>New Reservation</h2>
      <div className="form-container">
        <label>
          Date:
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className="input-field"
          />
        </label>
        <label>
          Start Time:
          <input
            type="time"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
            className="input-field"
          />
        </label>
        <label>
          End Time:
          <input
            type="time"
            value={endTime}
            onChange={(e) => setEndTime(e.target.value)}
            className="input-field"
          />
        </label>
        <label className="checkbox">
          <input
            type="checkbox"
            checked={bookDesk}
            onChange={(e) => setBookDesk(e.target.checked)}
          />
          Reserve a desk as well
        </label>
        <label>
  Parking place:
  <select
    value={parkingPlace}
    onChange={(e) => setParkingPlace(e.target.value)}
    className="input-field"
  >
    <option value="">No preference</option>
    <option value="PS.LOD.-2.2.13">PS.LOD.-2.2.13</option>
    <option value="PS.LOD.-2.2.15">PS.LOD.-2.2.15</option>
    <option value="PS.LOD.-2.2.16">PS.LOD.-2.2.16</option>
    <option value="PS.LOD.-2.2.17">PS.LOD.-2.2.17</option>
    <option value="PS.LOD.-2.2.18">PS.LOD.-2.2.18</option>
    <option value="PS.LOD.-2.2.19">PS.LOD.-2.2.19</option>
    <option value="PS.LOD.-2.2.20">PS.LOD.-2.2.20</option>
    <option value="PS.LOD.-2.2.21">PS.LOD.-2.2.21</option>
    <option value="PS.LOD.-2.2.22">PS.LOD.-2.2.22</option>
    <option value="PS.LOD.-2.2.23">PS.LOD.-2.2.23</option>
    <option value="PS.LOD.-2.2.24">PS.LOD.-2.2.24</option>
    <option value="PS.LOD.-2.2.25">PS.LOD.-2.2.25</option>
    <option value="PS.LOD.-2.2.26">PS.LOD.-2.2.26</option>
    <option value="PS.LOD.-2.2.36">PS.LOD.-2.2.36</option>
    <option value="PS.LOD.-2.2.27">PS.LOD.-2.2.27</option>
    <option value="PS.LOD.-2.2.29">PS.LOD.-2.2.29</option>
    <option value="PS.LOD.-2.2.30">PS.LOD.-2.2.30</option>
    <option value="PS.LOD.-2.2.31">PS.LOD.-2.2.31</option>
    <option value="PS.LOD.-2.2.32">PS.LOD.-2.2.32</option>
    <option value="PS.LOD.-2.2.70">PS.LOD.-2.2.70</option>
    <option value="PS.LOD.-2.2.71">PS.LOD.-2.2.71</option>
    <option value="PS.LOD.-2.2.72">PS.LOD.-2.2.72</option>
    <option value="PS.LOD.-2.2.73">PS.LOD.-2.2.73</option>
    <option value="LOD.-2.2.74">LOD.-2.2.74</option>
    <option value="PS.LOD.-2.2.75">PS.LOD.-2.2.75</option>
    <option value="PS.LOD.-2.2.76">PS.LOD.-2.2.76</option>
    <option value="PS.LOD.-2.2.77">PS.LOD.-2.2.77</option>
    <option value="PS.LOD.-2.2.78">PS.LOD.-2.2.78</option>
    <option value="PS.LOD.-2.2.79">PS.LOD.-2.2.79</option>
    <option value="PS.LOD.-2.2.80">PS.LOD.-2.2.80</option>
    <option value="PS.LOD.-2.2.81">PS.LOD.-2.2.81</option>
    <option value="PS.LOD.-2.2.82">PS.LOD.-2.2.82</option>
    <option value="PS.LOD.-2.2.83">PS.LOD.-2.2.83</option>
    <option value="PS.LOD.-2.2.84">PS.LOD.-2.2.84</option>
    <option value="PS.LOD.-2.2.85">PS.LOD.-2.2.85</option>
    <option value="PS.LOD.-2.2.86">PS.LOD.-2.2.86</option>
    <option value="PS.LOD.-2.2.87">PS.LOD.-2.2.87</option>
    <option value="PS.LOD.-2.2.88">PS.LOD.-2.2.88</option>
    <option value="PS.LOD.-2.2.89">PS.LOD.-2.2.89</option>
    <option value="PS.LOD.-2/2.28">PS.LOD.-2/2.28</option>
  </select>
</label>
        <button className="book-btn" onClick={handleBook} disabled={isBookLoading}>{isBookLoading ? <TailSpin color="white" height={20} width={20} /> : "Book Reservation"}</button>
      </div>

      {/* Update Token Form */}
      <h2>Update Token</h2>
      <div className="form-container">
        <label>
          New Token:
          <input
            type="text"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            className="input-field"
          />
        </label>
        <button className="update-btn" onClick={handleUpdateToken} disabled={isUpdateLoading}>{isUpdateLoading ? <TailSpin color="white" height={20} width={20} /> : "Update Token"}</button>
        <button onClick={removeStoredPassword} className="remove-btn">Remove Stored Password</button>
    </div>
   </div>
  );
};

export default App;